import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { formIsFilled, formIsEmpty } from '../utils/helpers/validation';
import { clearFieldErrors } from '../utils/helpers/validation';
const useFormDisabledStates = (
  form,
  initials,
  title = 'title',
  slugOrPosition = 'slug',
  showPredefined = false,
) => {
  const [disabledStates, setDisabledStates] = useState({
    en: true,
    sk: true,
  });

  const updateDisabledState = (value, field, language) => {
    if (!language) {
      return;
    }

    setDisabledStates((prevStates) => ({
      ...prevStates,
      [language]: !formIsFilled(
        form,
        language,
        title,
        slugOrPosition,
        showPredefined,
      ),
    }));
    if (
      !value &&
      formIsEmpty(form, language, title, slugOrPosition, showPredefined)
    ) {
      clearFieldErrors(form, [
        `${title}_${language}`,
        `${slugOrPosition}_${language}`,
        `content_${language}`,
      ]);
    } else if (value && field) {
      clearFieldErrors(form, [`${field}_${language}`]);
    }
  };

  const setInitialValues = () => {
    const newDisabledStates = {
      en: Object.keys(initials)
        .filter((key) => key.endsWith('_en'))
        .some((key) => initials[key] === undefined || initials[key] === null),
      sk: Object.keys(initials)
        .filter((key) => key.endsWith('_sk'))
        .some((key) => initials[key] === undefined || initials[key] === null),
    };

    setDisabledStates(newDisabledStates);
  };

  useEffect(() => {
    setInitialValues();
  }, []);

  return {
    disabledStates,
    updateDisabledState,
  };
};

useFormDisabledStates.propTypes = {
  form: PropTypes.object,
  title: PropTypes.string,
  slugOrText: PropTypes.string,
  showPredefined: PropTypes.bool,
};

export default useFormDisabledStates;
